var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-container"},_vm._l((_vm.data),function(node,idx){return _c('MyTreeNode',{key:`${node.type}_${node.id}`,attrs:{"path":[],"level":idx,"node":node}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }